var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var PM_HUB_KEYWORDS = [
    'truck parking and repair',
    'truck repair and maintenance',
    'preventive maintenance for trucks',
    'truck breakdown support',
    'dispatch garage coordination',
    'diesel repair partners',
    'fleet maintenance coordination',
    'semi truck preventive maintenance',
    'truck service partner network',
    'truck PM services',
];
export var PM_HUB_KEYWORDS_STRING = PM_HUB_KEYWORDS.join(', ');
export var PM_SERVICE_INTENT_LINKS = [
    { path: '/truck-repair-and-maintenance', label: 'Repair + PM Overview' },
    { path: '/truck-repair-and-maintenance/preventive-maintenance', label: 'Preventive Maintenance' },
    { path: '/truck-repair-and-maintenance/truck-breakdown-support', label: 'Truck Breakdown Support' },
    { path: '/truck-repair-and-maintenance/garage-platform-management', label: 'Garage Platform Management' },
    { path: '/truck-repair-and-maintenance/dispatch-garage-coordination', label: 'Dispatch + Garage Coordination' },
];
var normalizeKeyword = function (value) {
    if (value === void 0) { value = ''; }
    return value.trim().toLowerCase();
};
var dedupeKeywords = function (values) {
    var seen = new Set();
    var unique = [];
    values
        .map(function (value) { return value.trim(); })
        .filter(Boolean)
        .forEach(function (value) {
        var normalized = normalizeKeyword(value);
        if (!normalized || seen.has(normalized))
            return;
        seen.add(normalized);
        unique.push(value);
    });
    return unique;
};
var collectPartnerServiceTerms = function (partner) {
    if (!Array.isArray(partner.services))
        return [];
    return partner.services.flatMap(function (category) {
        var categoryTerms = (category === null || category === void 0 ? void 0 : category.category) ? [category.category] : [];
        var itemTerms = Array.isArray(category === null || category === void 0 ? void 0 : category.items)
            ? category.items.map(function (item) { return (item === null || item === void 0 ? void 0 : item.name) || ''; }).filter(Boolean)
            : [];
        return __spreadArray(__spreadArray([], categoryTerms, true), itemTerms, true);
    });
};
export var buildPmPartnerKeywordsString = function (partner) {
    var focusTerms = Array.isArray(partner.seoFocusTerms) ? partner.seoFocusTerms : [];
    var serviceTerms = collectPartnerServiceTerms(partner);
    var partnerSpecificTerms = [
        "".concat(partner.name, " truck repair"),
        "".concat(partner.name, " preventive maintenance"),
        "".concat(partner.name, " diesel service"),
        partner.subtitle || '',
    ];
    return dedupeKeywords(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], PM_HUB_KEYWORDS, true), focusTerms, true), serviceTerms, true), partnerSpecificTerms, true)).join(', ');
};
